const goToWhatsapp = (number: string): string => {
    return `https://wa.me/${number}`;
};

export { goToWhatsapp };
